<template>
    <div>
        <section
            class="section section--slate050 section--slim section--overflowVisible"
        >
            <HeroBanner
                :header="dataHeroBanner.header"
                :image="dataHeroBanner.image"
                reverse-img
                disruptor-svg="one-hour-free-badge"
            />
        </section>

        <v-container class="container--slim" id="price">
            <SwitchLinks class="section" />

            <PriceSummary class="section" />

            <ListThreeColumns
                class="section"
                v-bind="dataUSPList"
                button-outline
                component-identifier="USP List"
                show-price-tables="true"
            />

            <Timeline
                class="section section--doubleSpacing section--dividerTop section--dividerBottom"
                :timeline="dataTimelinePrice"
            />

            <PriceCompare class="section" />

            <CustomerStoriesCards
                class="section section--doubleSpacing section--dividerBottom"
            />

            <CallCard class="section" />
        </v-container>

        <Prefooter>
            <template v-slot:left>
                <RelatedArticle :article="dataRelatedArticle" />
            </template>
            <template v-slot:right>
                <PostcodeSearch />
            </template>
        </Prefooter>
    </div>
</template>

<script>
import SwitchLinks from '@/components/molecules/switch/links.vue'
import HeroBanner from '@/components/organisms/heroBanner/wide.vue'
import ListThreeColumns from '@/components/organisms/list/listThreeColumns.vue'
import PriceCompare from '@/components/organisms/priceCompare.vue'
import Timeline from '@/components/organisms/timeline.vue'
import CustomerStoriesCards from '@/components/organisms/CustomerStories/cardStory.vue'
import CallCard from '@/components/organisms/CallCard.vue'
import Prefooter from '@/components/organisms/footer/Prefooter.vue'
import PostcodeSearch from '@/components/molecules/prefooter/postcodeSearch.vue'
import RelatedArticle from '@/components/molecules/prefooter/relatedArticle.vue'
import TimelineStep from '@/components/molecules/timeline/timelineStep.vue'
import PriceSummary from '@/components/organisms/priceSummary.vue'
import Banner from '@/components/atoms/banner'

export default {
    name: 'NativePreis',
    path: 'preis',
    layout: 'native',

    components: {
        SwitchLinks,
        HeroBanner,
        ListThreeColumns,
        PriceCompare,
        Timeline,
        CustomerStoriesCards,
        CallCard,
        Prefooter,
        PostcodeSearch,
        RelatedArticle,
        PriceSummary,
    },

    data: () => ({
        dataHeroBanner: {
            header: 'Preise & Pflegekasse',
            image: 'heroBanner/_SGA6712-Bearbeitet',
        },
        dataRelatedArticle: {
            title: 'So können Sie Careship Leistungen von der Steuer absetzen',
            text:
                'Wie Sie Ihre jährliche Steuerschuld um bis zu 4.000 Euro mindern.',
            ctaText: 'Mehr zur Steuerentlastung',
            ctaLink: '/senioren-ratgeber/leistungen-von-der-steuer-absetzen/',
            image: 'heroBanner/shutterstock_745519105',
        },
        dataTimelinePrice: [
            {
                wide: true,
                title: 'Transparente Abrechnung',
                image: 'graphics/scene-office-desk.png',
            },
            {
                banner: true,
                wide: true,
                contentComponent: Banner,
                contentProps: {
                    message:
                        'NEU: In Berlin ist durch Careship Ambulant die direkte Abrechnung über Ihre Pflegekasse möglich.',
                    icon:
                        'https://s3.eu-central-1.amazonaws.com/static.careship.de/corporate-identity/careship-ambulant/logos/CS-Ambulant-Logo-Element.png',
                    linkText: 'Hier erfahren Sie mehr!',
                    href: '/senioren-ratgeber/alltagshilfe-abrechnen/',
                },
            },
            {
                contentComponent: TimelineStep,
                contentProps: {
                    label: '1',
                    header:
                        'Buchen Sie Ihre Alltagshilfe stundenweise mit Careship.',
                    text:
                        'Individuell abgestimmt mit Ihrem persönlichen Alltagshelfer',
                },
            },
            {
                dashed: true,
                contentComponent: TimelineStep,
                contentProps: {
                    label: '2',
                    header:
                        'Begleichen Sie die monatliche Rechnung ganz einfach per Überweisung.',
                    text:
                        'Monatliche Rechnung inkl. Übersicht aller geleisteten Stunden und Überweisung direkt an Ihren Alltagshelfer',
                },
            },
            {
                contentComponent: TimelineStep,
                contentProps: {
                    label: '3',
                    header:
                        'Lassen Sie sich die Kosten über die Pflegekasse erstatten.',
                    text: 'Möglich ab Pflegegrad 2 oder höher',
                    button: {
                        href: '/preise/pflegekasse',
                        text: 'Info zur Pflegekasse',
                    },
                },
            },
        ],
        dataUSPList: {
            title: 'Unterstützung, die sich Ihnen anpasst ',
            subline: '',
            ctaLink: '/angebot/',
            ctaText: 'Leistungen im Überblick',
            list: [
                {
                    header: 'Keine Vertragsbindung',
                    text:
                        'Sie zahlen nur die Stunden, die Sie auch tatsächlich in Anspruch genommen haben.',
                    icon: 'calendar-clock',
                },
                {
                    header: 'Alle Leistungen, ein Preis',
                    text:
                        'Ob Hausarbeit, Erledigungen oder Begleitung - der Stundenpreis ist immer gleich.',
                    icon: 'icon-charge',
                },
                {
                    header: 'Erstattung über Pflegekasse',
                    text:
                        'Holen Sie sich entsprechend Ihren Ansprüchen Ihre Ausgaben von der Pflegekasse zurück.',
                    icon: 'business-contract-approve',
                },
            ],
        },
    }),

    head() {
        return {
            title: 'Kosten Seniorenbetreuung | Careship',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content:
                        'Sie möchten wissen, was eine stundenweise Seniorenbetreuung bei Careship kostet? Finden Sie hier einen Überblick über unsere Preise für Ihren Alltagshelfer',
                },
            ],
        }
    },
}
</script>
